module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "批量编辑",
      "width": "680"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 130
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作范围"
    }
  }, [_c('Radio-group', {
    on: {
      "on-change": _vm.onScopeChange
    },
    model: {
      value: (_vm.form.scope),
      callback: function($$v) {
        _vm.$set(_vm.form, "scope", $$v)
      },
      expression: "form.scope"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "IDS"
    }
  }, [_vm._v("勾选题目 ID（" + _vm._s(_vm.selectedCount) + "）")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "LEVEL"
    }
  }, [_vm._v("按级别")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "TYPE"
    }
  }, [_vm._v("按题型")])], 1)], 1), _vm._v(" "), (_vm.form.scope === 'IDS') ? _c('Form-item', {
    key: "scope-ids",
    attrs: {
      "label": "题目 ID"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "已勾选会自动填入该行版本 ID，也可逗号或换行补充"
    },
    model: {
      value: (_vm.form.ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "ids", $$v)
      },
      expression: "form.ids"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.scope === 'LEVEL') ? _c('Form-item', {
    key: "scope-level",
    attrs: {
      "label": "级别"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "placeholder": "选择一个或多个级别"
    },
    model: {
      value: (_vm.form.levelCodes),
      callback: function($$v) {
        _vm.$set(_vm.form, "levelCodes", $$v)
      },
      expression: "form.levelCodes"
    }
  }, _vm._l((_vm.levels), function(lv) {
    return _c('Option', {
      key: lv,
      attrs: {
        "value": lv
      }
    }, [_vm._v(_vm._s(lv))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.scope === 'TYPE') ? _c('Form-item', {
    key: "scope-type",
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "选择题库中的题型"
    },
    model: {
      value: (_vm.form.questionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "questionType", $$v)
      },
      expression: "form.questionType"
    }
  }, _vm._l((_vm.questionTypes), function(t) {
    return _c('Option', {
      key: t,
      attrs: {
        "value": t
      }
    }, [_vm._v(_vm._s(_vm.questionTypeLabel(t, _vm.typeSkill)))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.bank === 'comp' && _vm.form.scope !== 'IDS') ? _c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "不选则该级别/题型全部技能"
    },
    on: {
      "on-change": _vm.loadQuestionTypes
    },
    model: {
      value: (_vm.form.skill),
      callback: function($$v) {
        _vm.$set(_vm.form, "skill", $$v)
      },
      expression: "form.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "英文指令"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.form.updateEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "updateEn", $$v)
      },
      expression: "form.updateEn"
    }
  }, [_vm._v("修改 question_direction")]), _vm._v(" "), (_vm.form.updateEn) ? _c('Input', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "将覆盖选中题目当前版本的英文指令"
    },
    model: {
      value: (_vm.form.instructionEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionEn", $$v)
      },
      expression: "form.instructionEn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "中文指令"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.form.updateCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "updateCn", $$v)
      },
      expression: "form.updateCn"
    }
  }, [_vm._v("修改 question_direction_chinese")]), _vm._v(" "), (_vm.form.updateCn) ? _c('Input', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "将覆盖选中题目当前版本的中文指令"
    },
    model: {
      value: (_vm.form.instructionCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionCn", $$v)
      },
      expression: "form.instructionCn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Radio-group', {
    model: {
      value: (_vm.form.statusAction),
      callback: function($$v) {
        _vm.$set(_vm.form, "statusAction", $$v)
      },
      expression: "form.statusAction"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "none"
    }
  }, [_vm._v("不改状态")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "online"
    }
  }, [_vm._v("上线")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "offline"
    }
  }, [_vm._v("下线")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "discard"
    }
  }, [_vm._v("废弃")])], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("已上线须先下线再废弃。指令改当前版本，不升版本。")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00612eb7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexQuestionBatchModal.vue
// module id = 1603
// module chunks = 8